import { Component } from '@angular/core';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';
import { ImageBlock } from './image-block';
import { ContentModule } from '@tytapp/content';


@Component({
    selector: 'tyt-image-block',
    standalone: true,
    imports: [
        ContentModule
    ],
    template: `
        <div class="image-container">
          @if (block.url) {
            <a url="{{block.url}}">
              <picture responsive [src]="block.image"></picture>
            </a>
          }
          @if (!block.url) {
            <picture responsive [src]="block.image"></picture>
          }
          <caption>
            @if (block.image_caption) {
              <span class="cms-content" [innerHTML]="block.image_caption | markdownToHtml | trustHtml"></span>
            }
            @if (block.image_credit) {
              <span class="cms-content" [innerHTML]="block.image_credit | markdownToHtml | trustHtml"></span>
            }
          </caption>
        </div>
        `,
    styles: [`
        caption {
            display: block;
            color: #888;
            padding: 0.75em 0 1.25em 0;
            font-size: 0.8em;

            & ::ng-deep p {
                display: inline;
            }
        }
    `]
})
export class ViewComponent extends ContentBlockViewComponent<ImageBlock> {
}
